module.exports = __webpack_public_path__ + "31a71554a7917f4d60fb34b775a158da.jpg";